import React, { useState } from "react";
import { UserInfo } from "@/user-control/types/UserInfo";
import { Alert, Button, Table } from "antd";
import useBoolean from "@/hooks/useBoolean";
import styled from "@emotion/styled";
import useNonPaginatedTable from "@/hooks/useNonPaginatedTable";
import { useNavigate } from "react-router-dom";
import { colors } from "@/config/theme";
import { FileExcelOutlined } from "@ant-design/icons";
import { getStaffTableColumns } from "./columns";
import ExportDateRangeModal from "../ExportDateRangeModal";

const AlertTitle = styled.b`
  color: ${colors.daybreakBlue[100]};
`;

interface StaffTableProps {
  data: UserInfo[];
}

const StaffTable = ({ data }: StaffTableProps) => {
  const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const exportDateRangeModal = useBoolean(false);

  const handleViewDetailsClick = (userId: number) => {
    navigate(`/time-tracking/timesheet/${userId}`);
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const tableColumns = getStaffTableColumns(handleViewDetailsClick);

  const { columns } = useNonPaginatedTable({
    columns: tableColumns,
  });

  return (
    <>
      {selectedRowKeys.length > 0 && (
        <Alert
          message={<AlertTitle>Export selected timesheets</AlertTitle>}
          type="info"
          action={
            <Button
              icon={<FileExcelOutlined />}
              type="primary"
              onClick={() => {
                exportDateRangeModal.setTrue();
              }}
            >
              Export as XLSX
            </Button>
          }
          style={{
            position: "sticky",
            top: 60,
            zIndex: 1000,
          }}
        />
      )}
      <Table<UserInfo>
        dataSource={data}
        columns={columns}
        rowKey={(row) => row.UserId}
        pagination={false}
        rowSelection={{
          onChange: onSelectChange,
          selectedRowKeys,
          columnWidth: 50,
        }}
      />
      <ExportDateRangeModal
        open={exportDateRangeModal.value}
        onClose={exportDateRangeModal.setFalse}
        selectedUserIds={selectedRowKeys.map((key) => Number(key))}
      />
    </>
  );
};

export default StaffTable;
